// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__NYi8h","centerAlignedColumn":"Logout_centerAlignedColumn__rFneF","loginText":"Logout_loginText__fW5M0"};